import { createIcon } from './create-icon'

export const StarO = createIcon({
  displayName: 'StarO',
  paths: [
    'M511.991 85.333c-17.323 0-34.645 9.216-43.264 27.605l-104.447 223.445-238.336 36.565c-38.443 5.888-54.144 52.992-26.965 80.981l173.995 179.115-40.533 249.771c-5.035 30.976 19.499 55.851 47.189 55.851 7.637 0 15.531-1.877 23.083-6.101l209.279-116.181 209.28 116.181c7.552 4.224 15.445 6.101 23.083 6.101 27.691 0 52.224-24.875 47.189-55.851l-40.533-249.771 173.995-179.115c27.179-27.989 11.477-75.093-26.965-80.981l-238.336-36.565-104.448-223.445c-8.619-18.389-25.941-27.605-43.264-27.605z'
  ]
})
